module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=BQ - Bonaire Sint Eustatius and Saba.ddcb29ae.svg";